import { useNavToChatOnNotificationClick } from 'app/core/notifications/fcm-service';
import { contextActions } from 'app/core/redux/context-redux';
import { useAuthToken } from 'app/core/token/token-utils';
import { NavActions } from 'app/shared/page-parts/BottomNav';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { LSKey } from './local-storage/local-storage.types';
import useLocalState from './local-storage/use-local-storage';
import { useEffectOnce } from './misc-hooks';

type UseSetupAppHook = {
  showWelcome: boolean;
};
export default function useSetupApp(
  navActions: NavActions
): UseSetupAppHook {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const auth = useAuthToken();
  const [welcomed, , getSyncWelcomed] = useLocalState(
    LSKey.WELCOMED,
    false
  );
  useEffectOnce(() => {
    dispatch(contextActions.navActions.set(navActions));
  });

  useNavToChatOnNotificationClick();
  return {
    showWelcome:
      // check welcomed state (to catch updates) but also check
      // synchronous value to see if it's been set between renders
      !(welcomed || getSyncWelcomed()) &&
      !auth &&
      pathname !== SharedRoutePath.WELCOME &&
      pathname !== SharedRoutePath.CONFIRM_PASSWORD,
  };
}
